// extracted by mini-css-extract-plugin
export default {"legendItem":"ReturnPeriod_legendItem__rhxwr","lagend":"ReturnPeriod_lagend__FO+Pt","active":"ReturnPeriod_active__dSdzQ","value":"ReturnPeriod_value__6yBRK"};